import { WHY_TO_JOIN_LIST_ITEMS } from "../../constants/landingPage";

const WhyToJoinListItem = ({ Icon, title, subTitle }) => (
  <div className="why-join__item">
    <div className="why-join__item-icon">
      <Icon className="why-join__item-icon-img" color="#BE1622" />
    </div>
    <div className="why-join__item-text">
      <p className="why-join__item-title">{title}</p>
      <p className="why-join__item-subtitle">{subTitle}</p>
    </div>
  </div>
);

const WhyToJoin = () => (
  <div className="why-join">
    <div className="why-join__heading">
      <p className="why-join__title">
        لماذا تشترك في{" "}
        <span className="why-join__title-span">تدرب للأعمال؟</span>
      </p>
    </div>
    <div className="why-join__list">
      {WHY_TO_JOIN_LIST_ITEMS.map(({ id, Icon, title, subTitle }) => (
        <WhyToJoinListItem key={id} Icon={Icon} title={title} subTitle={subTitle} />
      ))}
    </div>
  </div>
);

export default WhyToJoin;
